// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2uqxf","largestCol":"styles_largestCol__2GX1t","smallestCol":"styles_smallestCol__2ls7V"};